<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100 p-t-190 p-b-30">
        <form class="login100-form validate-form" @submit.prevent="Submit">
          <div class="login100-form-avatar">
            <img :src="Holding" alt="AVATAR" />
          </div>
          <span class="login100-form-title p-t-20 p-b-45">
            پرتال سهامداران تبرک</span
          >
          <div
            class="wrap-input100 validate-input m-b-10"
            data-validate="Username is required"
          >
            <input
              class="form-control"
              type="text"
              placeholder="لطفا شماره همراه خودراوارد نمایید"
              v-model="user.PhoneNumber"
              required
            />
          </div>
          <div class="container-login100-form-btn p-t-10">
            <button class="submit" type="submit">ارسال</button>
          </div>
          <div class="text">
            <router-link to="/login" class="link">
              <p>ورود به پرتال سهام</p>
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { ForgotPassword } from "@/API/API";
import Holding from "../assets/img/HOLDING.png";

export default {
  name: "PassWord",
  data() {
    return {
      Holding,
      user: {
        PhoneNumber: "",
      },
      loginError: false,
    };
  },
  methods: {
    Submit() {
      ForgotPassword(this.user).then((resp) => {
        if (resp.data.statusCode == 404) {
          this.$swal({
            icon: "error",
            title: "خطا",
            text: "این شماره همراه یافت نشد برای اطلاعات بیشتر با شماره 37501 داخلی 180 تماس بگیرید",
            confirmButtonColor: "#900C3F",
            confirmButtonText: "باشه",
          });
        } else {
          this.$swal({
            icon: "success",
            title: "موفق",
            text: "ارسال پیام باموفقیت انجام شد",
            confirmButtonColor: "#1e682d",
            confirmButtonText: "باشه",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
input {
  text-align: center;
}
.link {
  color: #fff;
}
a:hover {
  color: #fff;
}
</style>
